import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { SIDEBAR_CHECKOUT_CONTENT } from './constants';
import styles from './sidebarPowerCheckout.scss';

const PastDueWarning = ({ details }) => {
    if (!details?.renewalDate || !details?.cardBrand || !details?.last4) {
        return (
            <div className={styles.pastDueWarningPlaceholder} data-test="past-due-warning-placeholder">
                <div className={styles.pastDuePlaceholderLine} />
                <div className={styles.pastDuePlaceholderLine} />
                <div className={styles.pastDuePlaceholderLineShort} />
            </div>
        );
    }

    const formattedDate = moment(details.renewalDate).format('MMM D, YYYY');
    const brand = details.cardBrand.charAt(0).toUpperCase() + details.cardBrand.slice(1);

    return (
        <div className={styles.pastDueWarning} data-test="past-due-warning">
            <span className={styles.pastDueWarningBold}>
                {SIDEBAR_CHECKOUT_CONTENT.pastDueWarning.boldPrefix(formattedDate, brand, details.last4)}
            </span>
            {SIDEBAR_CHECKOUT_CONTENT.pastDueWarning.suffix}
        </div>
    );
};

PastDueWarning.propTypes = {
    details: PropTypes.shape({
        renewalDate: PropTypes.string,
        cardBrand: PropTypes.string,
        last4: PropTypes.string,
    }),
};

PastDueWarning.defaultProps = {
    details: null,
};

export default PastDueWarning;
